import React from 'react'
import moment from 'moment'
import { Popup, Button, Table, Label } from 'semantic-ui-react'
import get from 'lodash/get'

import firebase from 'firebase/app'
import utils from '../../../../utils'

export default class OrderAtCell extends React.PureComponent {
  state = { remainingEta: 0 }

  componentDidMount() {
    const { order } = this.props

    if (order.status !== 'rejected' && order.status !== 'delivered') {
      this.calculateRemaining()
    }
  }

  componentDidUpdate(prevProps) {
    const { order } = this.props

    const nextOrderIsRtp = get(order, 'item_preparation_status', false)
    const oldOrderIsRtp = get(prevProps.order, 'item_preparation_status', false)

    if ((!oldOrderIsRtp && typeof nextOrderIsRtp === 'number') || oldOrderIsRtp !== nextOrderIsRtp) {
      this.calculateRemaining()
    }
  }

  componentWillUnmount() {
    clearInterval(this.etaTimer)
  }

  calculateRemaining = () => {
    const { order } = this.props

    const orderSummary = utils.order.getOrderSummary(order)
    const delayMinutesInOrder =
      typeof order.item_preparation_status === 'number' ? order.item_preparation_status : 0
    const remainingEta = orderSummary.remainingTime + delayMinutesInOrder

    this.setState({ remainingEta }, this.countdownRemaining)
  }

  countdownRemaining = () => {
    clearInterval(this.etaTimer)

    this.etaTimer = setInterval(() => {
      let { remainingEta } = this.state

      remainingEta -= 1

      this.setState({ remainingEta })
    }, 1000 * 60)
  }

  clearSchedule = () => {
    const { order } = this.props

    const conf = window.confirm('Are you sure to remove schedule?')

    if (conf) {
      const updates = {}

      updates[`orders/${order.key}/delivery_time`] = 'ETA'

      firebase
        .database()
        .ref()
        .update(updates)
    }
  }

  canStartOrder = () => {
    const { order } = this.props

    const scheduled = moment(order.delivery_time)
    const shouldOrder = scheduled.subtract(parseInt(order.order_took_eta, 10), 'minutes')

    return {
      format: shouldOrder.format('hh:mm a'),
      color: moment().isSameOrAfter(shouldOrder) ? { color: 'orange' } : {},
    }
  }

  render() {
    const { order, readOnly } = this.props
    const { remainingEta } = this.state
    const color = remainingEta < 0 ? { color: 'red' } : {}

    const isShowETA = order.status !== 'rejected' && order.status !== 'delivered'
    const isScheduled = isShowETA && order.delivery_time !== undefined && order.delivery_time !== 'ETA'

    return (
      <Table.Cell textAlign="center">
        <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(order.created_at).fromNow()}</span>
        <br />
        {moment(order.created_at).format('HH:mm a')}
        <br />
        {moment(order.created_at).format('DD-MMM-YYYY')}
        <br />
        {isShowETA && (
          <Label {...color} style={{ marginTop: 3 }}>
            {`ETA: ${remainingEta} minutes`}
          </Label>
        )}
        <br />
        {isScheduled && (
          <Popup
            on="click"
            hideOnScroll
            wide
            trigger={
              <Label style={{ margin: 0, marginTop: 3, width: 110 }} {...this.canStartOrder().color}>
                Schedule
              </Label>
            }
            position="top center"
          >
            <div style={{ margin: '5px 0px', textAlign: 'center' }}>
              <React.Fragment>
                Scheduled at <Label>{moment(order.delivery_time).format('hh:mm a')}</Label>
              </React.Fragment>
              <div style={{ marginTop: 5 }}>
                Should order at <Label>{this.canStartOrder().format}</Label>
              </div>
              <div style={{ textAlign: 'center', marginTop: 5 }}>
                <Button onClick={this.clearSchedule} size="mini" disabled={readOnly}>
                  Clear Schedule?
                </Button>
              </div>
            </div>
          </Popup>
        )}
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/OrderAtCell.js